module.exports = __webpack_public_path__ + "img/track.cecdb092.png";